import api from '@/api/api.js'

export default {
    getTarifByGroupPrestation(data) {
        const promise = api.clinique().post("/bon-medical/tarif-prestations", data);
        return promise.then((response) => response.data);
    },

    saveBulletinAnalyse(data) {
        const promise = api.clinique().post("/bulletins/save/analyses", data);
        return promise.then((response) => response.data);
    },

    saveDemandeExamen(data) {
        const promise = api.clinique().post('/examens/save_demande', data)
        return promise.then((response) => response.data)
    },

    getTarifListePrestation(data) {
        const promise = api.clinique().post("/prestations/tarif-prestation", data);
        return promise.then((response) => response.data);
    },

    setPaidDemandeAnalyse(data) {
        const promise = api.clinique().post('/demande-analyses/update', data)
        return promise.then((response) => response.data)
    },

    setPaidDemandeExamen(data) {
        const promise = api.clinique().post('/demande-examens/update', data)
        return promise.then((response) => response.data)
    },

    setPaidPharmacieArticle(data) {
        const promise = api.clinique().post('/prescriptions/valider-paiement', data)
        return promise.then((response) => response.data)
    },

    setPaidProtocoleConstitution(data) {
        const promise = api.clinique().post('/protocoles/valider-paiement', data)
        return promise.then((response) => response.data)
    },

    getTarificationTypeAdmission(data) {
        const promise = api.clinique().post('/assurances/tarification/type-admission', data)
        return promise.then(response => response.data)
    },

    getTarifActe(type_acte) {
        const promise = api.clinique().get('/prestations/actes/'+type_acte)
        return promise.then(response => response.data)
    },

    getTarifBilanSante(data) {
        const promise = api.clinique().get('/assurances/tarification/bilan-sante/0/'+data.assur_id)
        return promise.then(response => response.data)
    },

    getConsumableOfConsultation(data) {
        const promise = api.clinique().post('/config/consumables', data)
        return promise.then(response => response.data)
    },

    getTarifPrestation(data) {
        const promise = api.clinique().post('/prestations/tarif-prestation', data)
        return promise.then((response) => response.data)
    },

    getListeBilanSante() {
        const promise = api.clinique().get('/bilan-sante/liste')
        return promise.then((response) => response.data)
    },

    getTypesFacturationPrestation() {
        const promise = api.clinique().get('/types-facturation-prestation')
        return promise.then((response) => response.data)
    },
}